import { instance2, instance3 } from "App/constants";
import {
  urlDeleteItem,
  urlDeleteItemPaket,
  urlAddItem,
  urlAddItemPaket,
  urlGetById,
  urlGet,
  urlDelete,
} from "./constants";

export const getTarif = async () => {
  try {
    const response = await instance2.get("/kelaskunjungan/listtarif");
    return {
      state: true,
      data: response.data.body,
    };
  } catch (error) {
    return {
      state: false,
      message: "error",
    };
  }
};

export const deleteItemById = async (id, type = "rikjang") => {
  try {
    const res = await instance3.post(
      `${type === "rikjang" ? urlDeleteItem : urlDeleteItemPaket}`,
      {
        id,
      }
    );
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const addItemById = async (formData, type = "rikjang") => {
  try {
    let data = {};
    if (type === "rikjang") {
      data = {
        rikjang_id: formData.rikjang_id,
        item_type: formData.item_type,
        item_id: formData.item_id,
        qty: formData.qty,
      };
    } else {
      data = {
        id_paket: formData.paket_id,
        item_type: formData.item_type,
        item_id: formData.item_id,
        qty: formData.qty,
      };
    }
    const res = await instance3.post(
      `${type === "rikjang" ? urlAddItem : urlAddItemPaket}`,
      data
    );
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menambah data",
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getRikjangById = async (id, id_jenis_harga) => {
  try {
    const res = await instance3.post(`${urlGetById}`, {
      id,
      id_msHarga: id_jenis_harga,
    });
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data[0],
      };
    } else {
      return {
        state: false,
        message: res.sata.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteRikjangById = async (id) => {
  try {
    await instance3.post(
      urlDelete,
      {},
      {
        headers: {
          id: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterJenisHarga = async (
  formFilter,
  pages,
  limit,
  url = urlGet
) => {
  try {
    const api = await instance3.post(url, {
      id_msHarga: formFilter.id_jenis_harga,
      nama: formFilter.nama,
      id: formFilter.id,
      jumlah: limit,
      halaman: pages,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
